import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isEnabledForFrontierCopilotAudience, type FrontierFlightConfig, } from "./isEnabledForFrontierCopilotAudience";

const instructionsCalendarAgentFrontierFlights: FrontierFlightConfig = {
    publicFlight: "cal-ai-instructions-calendar-agent-frontier-public",
    privateTapFlight: "cal-ai-instructions-calendar-agent-frontier-private-tap",
    privateStagingFlight: "cal-ai-instructions-calendar-agent-frontier-private-staging",
    privateInfluencerFlight: "cal-ai-instructions-calendar-agent-frontier-private-influencer",
};

/**
 * Checks if the calendar agent is enabled for Calendar AI Instructions interactions.
 *
 * Returns true if EITHER:
 * - The global `cal-ai-instructions-calendar-agent` flight is on (conventional rollout), OR
 * - The user is a licensed frontier user and the frontier flight for their type is enabled
 */
export function isInstructionsCalendarAgentEnabled(mailboxInfo: MailboxInfo): boolean {
    return (isGlobalFeatureEnabled("cal-ai-instructions-calendar-agent") ||
        isEnabledForFrontierCopilotAudience(mailboxInfo, instructionsCalendarAgentFrontierFlights));
}
